import { ApiClientConfig } from "./api-client-config";
import { EditorConfig } from "./editor-config";
import { GetUserTokenRequest } from "./get-user-token-request";
import { RawProject } from "./raw-project";
import { UrlHelper } from "./url-helper";

export class ApiClient {

    public constructor(private _apiClientConfig: ApiClientConfig) 
    {}

    public async getIntegrationInfo(shopifyProductId: string) {
        try {
            const apiUrl = this.buildGetIntegrationInfoUrl(shopifyProductId);

            console.log('GetIntegrationBoUrl is :', apiUrl.href);

            const response = await fetch(apiUrl, {
                method: 'GET'
            });
            const data = await this.handleJsonResponse(response);
    
            return data.result;
        }
        catch (e) {
            console.error(e);
        }
    }

    public async getProductVariantIdBySku(sku: string) {
        try {
            const apiUrl = this.buildGetProductVariantIdBySku(sku);

            const response = await fetch(apiUrl, {
                method: 'GET'
            });
            
            return await this.handleJsonResponse(response);    
        }
        catch (e) {
            console.error(e);
        }
    }

    public async postRawProject(rawProject: RawProject) {
        try {
            const apiUrl = this.buildPostTemporaryProjectUrl();

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(rawProject)
            });
    
            return this.handleJsonResponse(response);
        }
        catch (e) {
            console.error(e);
        }
    }

    public async getPimProduct(productId: number, productVersionId: number, userToken: string) {
        try{
            const apiUrl = this.buildGetPimProductUrl(productId, productVersionId);
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: { 'Authorization': 'Bearer ' +  userToken},
            });

            const data = await this.handleJsonResponse(response);

            return data;
        }
        catch (e) {
            console.error(e);
        }
    }

    public async getUserToken() {
        try{
            const apiUrl = this.buildGetUserTokenUrl();
            const requestBody = this.buildGetUserTokenRequest();

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            });

            const data = await this.handleJsonResponse(response);

            return data.result.token;
        }
        catch (e) {
            console.error(e);
        }
    }

    private buildPostTemporaryProjectUrl() {
        const url = UrlHelper.urlCombine(
            this._apiClientConfig.adapterBaseUrl,
            'api/shopify-adapter/v1/raw-projects'
        );
        url.searchParams.append('tenantId', this._apiClientConfig.tenantId);

        return url;
    }

    private buildGetIntegrationInfoUrl(shopifyProductId: string) {
        const url = UrlHelper.urlCombine(
            this._apiClientConfig.backOfficeUrl,
            'api/v1/tenants',
            this._apiClientConfig.tenantId,
            'integrations',
            shopifyProductId);

        url.searchParams.append('storefrontId', this._apiClientConfig.ecommerceSystemId);

        return url;
    }

    private buildGetProductVariantIdBySku(sku: string) {
        const url = UrlHelper.urlCombine(
            this._apiClientConfig.adapterBaseUrl,
            'api/shopify-adapter/v1/products/get-variant-id-by-sku');

        url.searchParams.append('tenantId', this._apiClientConfig.tenantId);
        url.searchParams.append('storefrontId', this._apiClientConfig.ecommerceSystemId);
        url.searchParams.append('sku', sku);

        return url;
    }

    private buildGetPimProductUrl(productId: number, productVersionId: number) {
        const url = UrlHelper.urlCombine(
            this._apiClientConfig.backOfficeUrl,
            '/api/storefront/v1/products/',
            productId.toString());

        url.searchParams.append('productVersionId', productVersionId.toString());
        url.searchParams.append('tenantId', this._apiClientConfig.tenantId);

        return url;
    }

    private buildGetUserTokenUrl() {
        const url = UrlHelper.urlCombine(
            this._apiClientConfig.backOfficeUrl,
            '/api/v1/tenants/',
            this._apiClientConfig.tenantId,
            '/integrations/getusertoken');

        return url;
    }

    private buildGetUserTokenRequest() : GetUserTokenRequest {
        const request : GetUserTokenRequest = {
            ecommerceDomain: (window as any).location.origin,
            origin: (window as any).location.origin,
            storefrontId: this._apiClientConfig.ecommerceSystemId,
            userGuid: this._apiClientConfig.userId
        }
        return request;
    }

    private handleJsonResponse(response: Response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    }
}